"use strict";

import PpkHome from "./../views/ppk/PpkHome.vue";
import PpkTender from "./../views/ppk/PpkTender.vue";
import ApproveJadwal from "./../views/ppk/PpkApproveJadwal.vue";

const ppk = [
    {
        path: "/ppk",
        component: PpkHome
    },
    {
        path: "/ppk/tender",
        component: PpkTender
    },
    {
        path: "/ppk/approve-jadwal",
        component: ApproveJadwal
    }
];


export default ppk;
